import { t } from "i18next"
import { z } from "zod"
import { textAreaDefaultMaxLength } from "@/models/common"
import { NotBillableReason } from "@/types/__generated__/union-types"

const DeBillingSchema = z
  .object({
    isNotBillable: z.boolean(),
    reason: z.string().optional(),
    notBillableReason: z.custom<NotBillableReason>(),
    isVisualSymptomExamination: z.boolean().optional(),
  })
  .superRefine(({ isNotBillable, reason, notBillableReason }, ctx) => {
    if (isNotBillable && notBillableReason === "OTHER_REASON") {
      if (!reason) {
        ctx.addIssue({
          code: "custom",
          path: ["reason"],
          message: t("common.fieldErrorList.requiredField"),
        })
      } else if (reason.length > textAreaDefaultMaxLength) {
        ctx.addIssue({
          code: "custom",
          path: ["reason"],
          message: t("common.fieldErrorList.characterLimit"),
        })
      }
    }
  })

type DeBillingSchemaType = z.infer<typeof DeBillingSchema>

export { DeBillingSchema, type DeBillingSchemaType }
